import React from 'react'
import { IconButton, Menu, MenuItem } from '@material-ui/core/index'
import MenuToolsIcon from '@material-ui/icons/MoreVert'
import CancelDialog from './dialogs/cancelDialog'
import ReservationDialog from './dialogs/reservationDialog'
import AddOrderToGroupDialog from './dialogs/addOrderToGroupDialog'
import ReadyDialog from './dialogs/readyDialog'
import RemoveOrderToGroupDialog from './dialogs/removeOrderToGroupDialog'
import DownloadDialog from './dialogs/downloadDialog'
import PrintDialog from './dialogs/printDialog'
import TrackingDialog from './dialogs/trackingDialog'
import ReturnOrderDialog from './dialogs/returnOrderDialog'
import EditAddressDialog from './dialogs/editAddressDialog'
import ExtendDialog from './dialogs/extendDialog'
import InsureDialog from './dialogs/insureDialog'
import RecoveryDialog from './dialogs/recoveryDialog'
import CancelParcelDialog from './dialogs/cancelParcelDialog'
import { orderStateTypes } from '../../../server/shared'
import { connect } from 'react-redux'
import DownloadDeliveryReceiptDialog from './dialogs/downloadDeliveryReceiptDialog'
import PrintDeliveryReceiptDialog from './dialogs/printDeliveryReceiptDialog'
import ContactTimeDialog from './dialogs/contactTimeDialog'

class Component extends React.Component {
    state = { anchorEl: null }

    handleCloseMenu = () => {
        this.setState({ anchorEl: null })
    }

    render() {
        let userPermissions = this.props.appStore.userPermissions
        let reverseLogisticsPermission = userPermissions.find(
            (x) => x === 'reverseLogistics'
        )
        let ordersReadyToPickUp = this.props.ordersReadyToPickUp
        let minimumGroupToReadyForCollect = this.props.appStore.minimumGroupToReadyForCollect
        const order = this.props.orderData
        const { shopPickupAvailable } = this.props
        const {
            isReturnable,
            isCancellable,
            isReservable,
            isPickupable,
            isEditable,
            isExtendable,
            isInsurable,
            isRecoverable,
            isParcelDepositedCancellable,
            isGroupedToReadyForCollect
        } = order
        const isReverseLogistics = order.orderTypeId === 4
        let isExternalHaulerOrder = !!order.haulerId

        let show = {}
        show.cancelDialog = isCancellable
        show.returnOrderDialog =
            isReturnable &&
            reverseLogisticsPermission &&
            this.props.appStore.userPermissions.some((x) => x === 'returnOrder')
        show.reservationDialog =
            isReservable &&
            this.props.appStore.userPermissions.some(
                (x) => x === 'orderReserver'
            )
        show.addOrderToGroupDialog = minimumGroupToReadyForCollect > 1 && shopPickupAvailable && isPickupable && !isGroupedToReadyForCollect && ordersReadyToPickUp <= minimumGroupToReadyForCollect && !isReverseLogistics
        show.readyDialog = (shopPickupAvailable && isPickupable && !isGroupedToReadyForCollect) && (ordersReadyToPickUp >= minimumGroupToReadyForCollect || minimumGroupToReadyForCollect <= 1 || isReverseLogistics || isExternalHaulerOrder)
        show.removeOrderToGroupDialog = shopPickupAvailable && isGroupedToReadyForCollect && isPickupable
        show.editAddress = !isExternalHaulerOrder && isEditable
        show.extendDialog =
            isExtendable &&
            this.props.appStore.userPermissions.some(
                (x) => x === 'extendReserve'
            )
        show.insureDialog = isInsurable

        show.recoveryDialog = isRecoverable && (
            (order.orderStateId === orderStateTypes.abandoned && this.props.appStore.userPermissions.some((x) => x === 'recoveryOrder'))
            || (order.orderStateId === orderStateTypes.cancelled && this.props.appStore.userPermissions.some((x) => x === 'parcelDepositedCancellable'))
        )

        show.cancelParcelDialog = isParcelDepositedCancellable && this.props.appStore.userPermissions.some((x) => x === 'parcelDepositedCancellable')
        show.deliveryReceiptDialog = order.orderStateId === orderStateTypes.customerPickup

        show.contactTimeDialog = false

        return (
            <span>
                <IconButton
                    onClick={(e) =>
                        this.setState({ anchorEl: e.currentTarget })
                    }
                >
                    <MenuToolsIcon fontSize="small" />
                </IconButton>
                <Menu
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseMenu}
                >
                    <MenuItem onClick={this.handleCloseMenu}>
                        <TrackingDialog orderId={order.id} />
                    </MenuItem>

                    {!show.insureDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <InsureDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    <MenuItem onClick={this.handleCloseMenu}>
                        <DownloadDialog orderId={order.id} />
                    </MenuItem>

                    <MenuItem onClick={this.handleCloseMenu}>
                        <PrintDialog orderId={order.id} />
                    </MenuItem>

                    {!show.cancelDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <CancelDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.reservationDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ReservationDialog
                                orderId={order.id}
                                doorSizeId={order.doorSizeId}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.returnOrderDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ReturnOrderDialog
                                order={order}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.editAddress ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <EditAddressDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.extendDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ExtendDialog orderId={order.id} />
                        </MenuItem>
                    )}

                    {!show.addOrderToGroupDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <AddOrderToGroupDialog
                                orders={this.props.orders}
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                                ordersGroupedToReadyForCollect={this.props.ordersGroupedToReadyForCollect}
                            />
                        </MenuItem>
                    )}

                    {!show.readyDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ReadyDialog
                                orderIds={[order.id]}
                                actionDone={this.props.actionDone}
                                ordersGroupedToReadyForCollect={this.props.ordersGroupedToReadyForCollect}
                            />
                        </MenuItem>
                    )}

                    {!show.removeOrderToGroupDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <RemoveOrderToGroupDialog
                                orderId={[order.id]}
                                actionDone={this.props.actionDone}
                                ordersGroupedToReadyForCollect={this.props.ordersGroupedToReadyForCollect}
                            />
                        </MenuItem>
                    )}

                    {!show.recoveryDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <RecoveryDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.cancelParcelDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <CancelParcelDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.deliveryReceiptDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <DownloadDeliveryReceiptDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.deliveryReceiptDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <PrintDeliveryReceiptDialog
                                orderId={order.id}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}

                    {!show.contactTimeDialog ? null : (
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ContactTimeDialog
                                courierParcelId={order.courierParcelId}
                                actionDone={this.props.actionDone}
                            />
                        </MenuItem>
                    )}
                </Menu>
            </span>
        )
    }
}

const mapDispatchToProps = {}
const mapStateToProps = (store) => ({ appStore: store.app })
export default connect(mapStateToProps, mapDispatchToProps)(Component)
